export default function Badges({ badges, size = 'sm' }) {
  if (!badges || badges.length === 0) return null;
  const cls = size === 'sm' ? 'text-[10px] px-2 py-0.5' : 'text-xs px-2.5 py-1';
  return (
    <div className="flex flex-wrap gap-1.5" data-testid="badges-row">
      {badges.map(b => (
        <span key={b.code} title={b.description}
          className={`${cls} rounded-full border font-medium whitespace-nowrap`}
          style={{ background: `${b.color}20`, borderColor: `${b.color}55`, color: b.color }}>
          {b.label}
        </span>
      ))}
    </div>
  );
}
